export const DIMENSION_PUBLISHER = 'Publisher';
export const DIMENSION_AD_SET = 'AdSet';
export const DIMENSION_ROOT_AD_SET = 'RootAdSet';
export const DIMENSION_PARTNER_AD = 'PartnerAd';
export const DIMENSION_UNIQUE_PLACEMENT = 'UniquePlacement';
export const DIMENSION_PLACEMENT = 'Placement';

export const DIMENSION_ROOT_PARTNER_CAMPAIGN = 'RootPartnerCampaign';
export const DIMENSION_PARTNER_CAMPAIGN = 'PartnerCampaign';

//AdSet
export const METRIC_AD_SET_BID_AMOUNT = 'AdSetBidAmount';
export const METRIC_AD_SET_MIN_ROAS_BID = 'AdSetMinRoasBid';
export const METRIC_AD_SET_BIDING_STRATEGY = 'AdSetBidingStrategy';
export const METRIC_AD_SET_DAILY_BUDGET = 'AdSetDailyBudget';
export const METRIC_AD_SET_LIFETIME_BUDGET = 'AdSetLifetimeBudget';
export const METRIC_AD_SET_STATUS = 'AdSetStatus';
// PartnerAd
export const METRIC_PARTNER_AD_STATUS = 'Status';
export const METRIC_PARTNER_AD_BID_AMOUNT = 'AdBidAmount';

// PartnerCampaign
export const METRIC_AD_CAMPAIGN_DAILY_BUDGET = 'AdCampaignDailyBudget';
export const METRIC_AD_CAMPAIGN_LIFETIME_BUDGET = 'AdCampaignLifetimeBudget';
export const METRIC_AD_CAMPAIGN_BID_AMOUNT = 'AdCampaignBidAmount';
export const METRIC_AD_CAMPAIGN_STATUS = 'AdCampaignStatus';

//Placement
export const PLACEMENT_BID_AMOUNT = 'PlacementBidAmount';
export const PLACEMENT_STATUS = 'PlacementStatus';

// actions
export const EDIT_BID_AMOUNT = 'editBidAmount';
export const EDIT_DAILY_BUDGET = 'editDailyBudget';
export const EDIT_STATUS = 'editStatus';
export const EDIT_LIFETIME_BUDGET = 'editLifetimeBudget';

export const metricActionsMap = {
  [METRIC_AD_SET_BID_AMOUNT]: EDIT_BID_AMOUNT,
  [METRIC_AD_SET_DAILY_BUDGET]: EDIT_DAILY_BUDGET,
  [METRIC_AD_SET_LIFETIME_BUDGET]: EDIT_LIFETIME_BUDGET,
  [METRIC_AD_SET_STATUS]: EDIT_STATUS,
  [METRIC_PARTNER_AD_STATUS]: EDIT_STATUS,
  [METRIC_PARTNER_AD_BID_AMOUNT]: EDIT_BID_AMOUNT,
  [METRIC_AD_CAMPAIGN_DAILY_BUDGET]: EDIT_DAILY_BUDGET,
  [METRIC_AD_CAMPAIGN_LIFETIME_BUDGET]: EDIT_LIFETIME_BUDGET,
  [METRIC_AD_CAMPAIGN_STATUS]: EDIT_STATUS,
  [METRIC_AD_CAMPAIGN_BID_AMOUNT]: EDIT_BID_AMOUNT,
  [PLACEMENT_BID_AMOUNT]: EDIT_BID_AMOUNT,
  [PLACEMENT_STATUS]: EDIT_STATUS,
};
